import React from "react";
import "./Footer.css";
import { Typography, Link, Grid, Paper, styled } from '@mui/material';
import { getCurrentDate } from "../../common/dateFormatter";
import { Environment } from "../../environments/Environment";

const PREFIX = 'Footer';

const classes = {
    footerSection: `${PREFIX}-footerSection`,
    footerLink: `${PREFIX}-footerLink`,
    version: `${PREFIX}-version`
};

const StyledPaper = styled(Paper)((
    {
        theme
    }
) => ({
    [`& .${classes.footerSection}`]: {
        marginTop: 10,
        padding: "23px 47px",
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white
    },

    [`& .${classes.footerLink}`]: {
        color: theme.palette.common.white
    },

    [`& .${classes.version}`]: {
        color: theme.palette.common.white
    }
}));

const Copyright = () => {

    return (
        <Typography variant="body2" align="right">
            {'Copyright © '}
            <Link
                className={classes.footerLink}
                href="https://www.curinos.com/"
                target="_blank"
                underline="hover">Curinos</Link>
            {' '}
            {getCurrentDate().getFullYear()}
        </Typography>
    );
}

const Footer = (props) => {

    return (
        <StyledPaper elevation={3} className={props.className}>
            <Grid container className={classes.footerSection}>
                <Grid item xs={6}>
                    <Typography variant="body2">Fulcrum&nbsp;-&nbsp;<small className={classes.version}>v{Environment.appVersion}</small></Typography>
                </Grid>
                <Grid item xs={6}>
                    <Copyright />
                </Grid>
            </Grid>
        </StyledPaper>
    );
}

export default Footer;